import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const TicketItem = (props) => {
    return (
        <li>
            <FontAwesomeIcon className={"FontAwesome fa-2xl"} icon={props.icon} style={{marginRight:"20px"}} />{props.children}
        </li>
    )
}
export { TicketItem };